
import IndexButtonContent from "@/index/IndexButtonContent.vue";
import { defineComponent } from "vue";
export default defineComponent({
  components: { IndexButtonContent },
  props: {
    text: String,
    to: Object,
    href: String,
    underlineText: String,
  },
});
